$(function () {
    $('.title-select__item').click(function () {
        $('.similar-toggle-block').hide();
        $('.similar-toggle-block.' + $(this).data('value')).show();
        $(this).parents('.title-select').removeClass('show');
        $(this).parents('.title-select').find('.title-select__current').text($(this).data('text'))
    }).eq(0).click();

    $('.title-select__current').click(function () {
        $(this).parents('.title-select').toggleClass('show');
    });
})
